import React from 'react';
import { Alert, AlertProps } from '@mui/material';
import { styled } from '@mui/material/styles';

interface CustomAlertProps extends AlertProps {
    fontSize?: string;
    fontWeight?: number | string;
}

const StyledAlert = styled(Alert)<CustomAlertProps>(
    ({ theme, fontSize, fontWeight }) => ({
        borderRadius: theme.spacing(1.5),
        fontSize: fontSize || '12px',
        fontWeight: fontWeight || 400,
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        alignItems: 'center',
    }),
);

const CustomAlert: React.FC<CustomAlertProps> = ({
    fontSize,
    fontWeight,
    variant = 'filled',
    ...props
}) => {
    return (
        <StyledAlert
            fontSize={fontSize}
            fontWeight={fontWeight}
            variant={variant}
            {...props}
        />
    );
};

export default CustomAlert;
